import { SET_PRODUCT_DATA, SET_CHECK_LIST, SET_IS_RK } from '../actionTypes/village-detail';

export const setProductDataAction = productData => ({
    type: SET_PRODUCT_DATA,
    payload: productData
});

export const setCheckListAction = checkList => ({
    type: SET_CHECK_LIST,
    payload: checkList
});

export const setIsRKAction = isRKTariff => ({
    type: SET_IS_RK,
    payload: isRKTariff
});
